<template>
  <div
    id="Cool-9"
    :style="{
      height: `${pagesHeight}px`,
      overflow: 'hidden'
    }"
  >
    <div
      :style="{
        width: '1920px',
        height: bodyHeight || '1080px',
        'transformOrigin':'left top',
        'transform':`scale(${scalseNum})`,
        '-webkit-transform':`scale(${scalseNum})`,
        '-moz-transform':`scale(${scalseNum})`,
        '-o-transform':`scale(${scalseNum})`,
        '-ms-transform':`scale(${scalseNum})`
      }"
    >
      <div class="header">
        <h1>酷开9.0数据看板</h1>
      </div>
      <Cool9First></Cool9First>
      <Cool9Second></Cool9Second>
      <!-- <Cool9Three></Cool9Three> -->
    </div>
  </div>
</template>

<script>
import ccMapMixin from '@/mixins/ccmap'
import common from '@/mixins/common.js'
import scalseNum from '@/mixins/scalseNum.js'
import Cool9First from '@/components/Cool9/Cool9First.vue'
import Cool9Second from '@/components/Cool9/Cool9Second.vue'
export default {
  name: 'Cool9',
  mixins: [ccMapMixin, common, scalseNum],
  components: {
    Cool9First,
    Cool9Second
  },
  props: [

  ],
  data () {
    return {

    }
  },
  computed: {
    bodyHeight () {
      return this.$route.meta.bodyHeight || null
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  }
}
</script>

<style scoped lang="stylus">
#Cool-9 *
  box-sizing : border-box
#Cool-9 >>> *
  box-sizing : border-box
.header
  font-size: 34px
  font-weight: bold
  color: #fff
  text-align: center
  height: 88px
  line-height: 88px

#Cool-9
  >>> .unit-body
        overflow: hidden
        background-color: RGBA(255, 255, 255, 0.05)
  >>> .unit-header
        font-size: 24px
        padding-left: 20px
        height 54px
        line-height: 54px
        background-color: rgba(255, 255, 255, 0.1)
</style>
